import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Table, Dropdown, Menu, notification } from "antd";
import axios from "axios";

import { montarIcon } from "../../../../../shared/utils/Drive/file/getFileIcon";

import ModalLoading from "../../../../../shared/components/Modals/ModalLoading";
import ModalViewer from "../../../../../shared/components/Modals/ModalViewer";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const TabelaPastas = ({ pastas }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [docs, setDocs] = useState([]);

    const gerarPdf = id => {
        setIsLoading(true);
        axios({
            method: "get",
            url: "api/pdf/formulario-caso",
            params: {
                id
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setDocs([{ uri: url, fileName }]);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento.");
            })
            .finally(() => setIsLoading(false));
    };

    const gerarPdfPEI = id => {
        setIsLoading(true);
        axios({
            method: "get",
            url: "/api/pdf/formulario-plano-atendimento-pei",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso"),
                planoId: id,
                turmaRegular: true
            }
        })
            .then(response => {
                const { url, fileName } = response.data;
                setDocs([{ uri: url, fileName }]);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento.");
            })
            .finally(() => setIsLoading(false));
    };

    const MontarOpcoesMenu = record => {
        return (
            <Menu>
                <Menu.Item>
                    <Link to="#" onClick={() => (record.estudoId ? gerarPdf(record.estudoId) : gerarPdfPEI(record.planoId))}>
                        Descarregar
                    </Link>
                </Menu.Item>
            </Menu>
        );
    };

    const dataSource = pastas;

    const columns = [
        {
            title: "Nome",
            dataIndex: "nome",
            key: "nome",
            render: (text, record) => {
                return (
                    <a
                        style={{ color: "rgba(0,0,0,0.65)" }}
                        className="nome-ficheiro-icon"
                        href={record.ficheiro}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={e => e.stopPropagation()}
                    >
                        {montarIcon(record)} {text}
                    </a>
                );
            }
        },
        {
            title: "",
            dataIndex: "",
            width: 50,
            render: (text, record) => {
                return (
                    <Dropdown overlay={MontarOpcoesMenu(record)} placement="bottomLeft" trigger={["click"]}>
                        <a className="botao-icon-configs" onClick={e => e.preventDefault()}>
                            <i className="fas fa-cog" />
                        </a>
                    </Dropdown>
                );
            }
        }
    ];

    return (
        <>
            <div className="area-drive" style={{ marginTop: "20px" }}>
                <div className="desktop-only">{dataSource && <Table className="tabela" dataSource={dataSource} columns={columns} />}</div>
            </div>
            <ModalLoading visible={isLoading} text="A gerar documento..." />
            <ModalViewer visible={modalVisible} docs={docs} onCancel={() => setModalVisible(false)} />
        </>
    );
};

export default TabelaPastas;
